// removed by extract-text-webpack-plugin
module.exports = {"root":"InternalLoadLink__root--17C4m","bounce":"InternalLoadLink__bounce--2fSQD"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Library/InternalLoadLink/InternalLoadLink.css
// module id = ./src/components/Library/InternalLoadLink/InternalLoadLink.css
// module chunks = 1